import React, {useEffect, useState} from 'react';
import {Form, Grid, Header, Segment, Table} from 'semantic-ui-react';
import {toast} from "react-toastify";
import {useNavigate} from "react-router-dom";
import {ToasterConfig} from "../../../../config/ToasterConfig";
import {CreateManagerRequest} from "../../../../models/requests/create-manager-request";
import {ShortDto} from "../../../../models/short-dto";
import useClientService from "../../../../services/backoffice/hooks/useClientService";
import useManagerService from "../../../../services/backoffice/hooks/useManagerService";

const CreateManagerPage = () => {
    const [manager, setManager] = useState<Partial<CreateManagerRequest>>({});
    const navigate = useNavigate();
    const [clientes, setClients] = useState<ShortDto[]>([])
    const {getAllClientsShortDto} = useClientService();
    const {createManager} = useManagerService();


    const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const {name, value} = event.target;
        setManager((prevManager) => ({
            ...prevManager,
            [name]: value,
        }));
    };

    useEffect(() => {
        function ListClientes() {
            getAllClientsShortDto().then((response) => {
                setClients(response);
            })
                .catch(error => {

                })
        }

        ListClientes()
    }, [])


    const handleSubmit = async () => {
        try {
            await createManager(manager)
            navigate('/backoffice/managers/');
            toast.success('Gestor criado com sucesso', ToasterConfig.success);

        } catch (error) {
        }
    };

    return (
        <div>
            <Grid.Column mobile={16} tablet={8} computer={6}>
                <Header as="h3" textAlign="center" color={'green'}>
                    Gestores / Adicionar
                </Header>
                <Segment>
                    <Form onSubmit={handleSubmit}>

                        <Form.Input
                            fluid
                            label="Email"
                            placeholder="Email"
                            name="email"
                            value={manager?.email}
                            onChange={handleInputChange}
                            required
                        />

                        <Form.Input
                            label="Nome"
                            name="firstName"
                            type="text"
                            placeholder="Nome"
                            value={manager.firstName}
                            onChange={handleInputChange}
                            required
                        />

                        <Form.Input
                            label="Sobrenome"
                            name="lastName"
                            type="text"
                            placeholder="Sobrenome"
                            value={manager.lastName}
                            onChange={handleInputChange}
                            required
                        />
                        <Form.Input
                            label="CPF"
                            name="cpf"
                            type="text"
                            placeholder="CPF"
                            value={manager.cpf}
                            onChange={handleInputChange}
                            required
                            maxLength={14}
                            mask={"999.999.999-99"}
                        />
                        <Form.Input
                            label="Senha"
                            name="password"
                            type="password"
                            placeholder="Senha"
                            value={manager.password}
                            onChange={handleInputChange}
                            required
                        />
                        <Form.Input
                            label="Confirmação da senha"
                            name="passwordConfirmation"
                            type="password"
                            placeholder="Confirmação da senha"
                            value={manager.passwordConfirmation}
                            onChange={handleInputChange}
                            required
                        />

                        <Form.Select
                            label={'Cliente ao qual o gestor pertence'}
                            options={clientes}
                            placeholder='Selecione uma opção'
                            value={manager?.clienteId || ''}
                            required
                            search
                            clearable
                            onChange={(e: any, data: any) => {
                                const selectedValue = data.value;
                                setManager(prevGestor => ({...prevGestor, clienteId: selectedValue}));
                            }}
                        />


                        <Table.Row>
                            <Table.HeaderCell>
                                <Form.Button content="Voltar"
                                             icon='arrow left'
                                             onClick={() => navigate('/backoffice/managers/')} grey/>
                            </Table.HeaderCell>
                            <Table.HeaderCell>
                                <Form.Button content="Adicionar"
                                             type={"submit"}
                                             icon='save'
                                             color={"green"}/>
                            </Table.HeaderCell>
                        </Table.Row>
                    </Form>
                </Segment>
            </Grid.Column>
        </div>
    );
};

export default CreateManagerPage;
